"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserDetailsTimeoffs = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userDetailsTimeOffsQuery = (0, graphql_tag_1.default) `
query UserDetailsTimeOffs($workspaceId: ID!, $userId: ID!, $period: PeriodFreeInput) {
  role(workspace: $workspaceId, user: $userId) {
    user {
      timeOffs(period: $period, workspace: $workspaceId) {
        categoryId
        workMinutes
      }
    }
  }
}`;
const requestUserDetailsTimeoffs = async ({ workspaceId, userId, period, }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsTimeOffsQuery, {
        variables: {
            workspaceId,
            userId,
            period,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role?.user;
};
exports.requestUserDetailsTimeoffs = requestUserDetailsTimeoffs;
